import { render, staticRenderFns } from "./PlainSection.vue?vue&type=template&id=c51e0866&scoped=true&"
import script from "./PlainSection.vue?vue&type=script&lang=ts&"
export * from "./PlainSection.vue?vue&type=script&lang=ts&"
import style0 from "./PlainSection.vue?vue&type=style&index=0&id=c51e0866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51e0866",
  null
  
)

export default component.exports